import {
	OPERATION_COLUMNS,
	OPERATION_ITEMS_COLUMNS,
} from "@onesolution/constants";
import {
	ALL_MONDAY_SCHEMAS,
	MONDAY_SCHEMAS,
	type MONDAY_TYPES,
} from "@onesolution/monday";
import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export type OperationMessage = {
	body: string;
	id: string;
	text_body: string;
	created_at: string;
	creator: { email: string };
};

export type OperationItem = MONDAY_TYPES["base"] & {
	description: MONDAY_TYPES["text"];
	status: MONDAY_TYPES["status"];
	board: { id: "string" };
	deadline: MONDAY_TYPES["date"];
	creationDate: MONDAY_TYPES["date"];
	timeline: MONDAY_TYPES["text"];
	timelineOriginal: MONDAY_TYPES["timeline"];
	thumbnail: MONDAY_TYPES["file"];
	files: MONDAY_TYPES["file"];
	marketingPlans: { linked_item_ids: string[]; display_value: string };
	campaigns: { linked_item_ids: string[]; display_value: string };
	entities: MONDAY_TYPES["dropdown"];
	projects: { linked_item_ids: string[]; display_value: string };
	products: { linked_item_ids: string[]; display_value: string };
	services: { linked_item_ids: string[]; display_value: string };
	boxFolderId: MONDAY_TYPES["text"];
	expenses: MONDAY_TYPES["text"];
	supportDuration: MONDAY_TYPES["formula"];
	completionDuration: MONDAY_TYPES["formula"];
	proof: MONDAY_TYPES["text"];
	proofStatus: MONDAY_TYPES["status"];
	versionCount: MONDAY_TYPES["text"];
	subitems: Array<
		MONDAY_TYPES["base"] & { timeline: string; status: MONDAY_TYPES["status"] }
	>;
	updates: OperationMessage[];
};

export const operationDetailsQuery = (params: {
	id: string;
}) =>
	requestAndFormat(
		{
			defaultParams: {
				columnIds: [
					OPERATION_COLUMNS.description,
					OPERATION_COLUMNS.deadline,
					OPERATION_COLUMNS.creationDate,
					OPERATION_COLUMNS.timelineOriginal,
					OPERATION_COLUMNS.marketingPlans,
					OPERATION_COLUMNS.campaigns,
					OPERATION_COLUMNS.entities,
					OPERATION_COLUMNS.projects,
					OPERATION_COLUMNS.products,
					OPERATION_COLUMNS.services,
					OPERATION_COLUMNS.expenses,
					OPERATION_COLUMNS.versionCount,
					OPERATION_COLUMNS.supportDuration,
					OPERATION_COLUMNS.completionDuration,
					OPERATION_COLUMNS.boxFolderId,
					OPERATION_COLUMNS.thumbnail,
					OPERATION_COLUMNS.files,
				],
				subColumnIds: [
					OPERATION_ITEMS_COLUMNS.timeline,
					OPERATION_ITEMS_COLUMNS.status,
				],
			},
			gql: gql`
                query GetOperationDetails (
                    $columnIds: [String!],
                    $subColumnIds: [String!],
                    $id: ID!
                ) {
                    items (
                        ids: [$id]
                    ) {
                        id
                        name
						board {
							id
						}
						updates(limit: 500) {
							text_body
							id
							created_at
							creator {
								email
							}
						}
						${MONDAY_SCHEMAS.assets}
                        column_values(ids: $columnIds) {
                            ${ALL_MONDAY_SCHEMAS}

                            ... on BoardRelationValue {
                                linked_item_ids
                                display_value
                            }
                        }

                        subitems {
                            id
                            name
							column_values(ids: $subColumnIds) {
                            	${ALL_MONDAY_SCHEMAS}
                        	}
                        }
                    }
                }`,
			resultKey: "items",
			outType: {} as OperationItem,
		},
		params,
	);
